const linkedInActionConstants = {
  SET_LINKEDIN_IMPORT_START_TIME: 'SET_LINKEDIN_IMPORT_START_TIME',
  UNSET_LINKEDIN_IMPORT_START_TIME: 'UNSET_LINKEDIN_IMPORT_START_TIME',
  SET_LOADER_ON: 'SET_LOADER_ON',
  SET_LOADER_OFF: 'SET_LOADER_OFF',

  IMPORT_LINKEDIN_CONTACTS_SUCCESS: 'IMPORT_LINKEDIN_CONTACTS_SUCCESS',
};

export default linkedInActionConstants;
